import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { ArrowLeft, Copy, X } from "react-feather";
import TreffasTextField from "src/components/TreffasTextField";
import TreffasButton from "src/components/TreffasButton";
import TreffasStyle from "src/utils/TreffasStyle";
import { useTranslation } from "react-i18next";
import { useSnackbarContext } from "src/context/SnackbarContext";

const TREFFAS_BUTTON_EMBED_SRC =
  `${window.location.origin}${process.env.PUBLIC_URL || ""}/assets/images/treffas-button.png`;

const EmbedButton = ({ bookingURL, close, onChangeCategory }) => {
  const { t } = useTranslation();
  let buttonURL = `<a href="${bookingURL}"><img src="${TREFFAS_BUTTON_EMBED_SRC}" style="border-style: none" /></a>`;

  const { showSnackbar } = useSnackbarContext();
  return (
    <Box>
      <Box
        sx={{
          p: "20px",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <IconButton onClick={() => onChangeCategory("booking")}>
              <ArrowLeft size={20} />
            </IconButton>
          </Box>

          <Box>
            <IconButton onClick={() => close()}>
              <X size={20} />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{ mt: "4px" }}>
          <Typography
            sx={{
              fontFamily: "var(--font-grenettepromedium)",
              fontStyle: "normal",
              fontSize: "26px",
              lineHeight: "26px",
              letterSpacing: "-0.01em",
              color: "#000000",
              textAlign: "center",
            }}
          >
            {t("package.label.booking.add_btn_toyour_web")}
          </Typography>
        </Box>

        <Box sx={{ mt: "8px" }}>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "18px",
              textAlign: "center",
              color: "#6E757C",
            }}
          >
            {t("package.label.booking.add_btn_toyour_web.description")}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          px: "40px",
          mt: "28px",
        }}
      >
        <Box>
          <TreffasTextField
            InputProps={{ readOnly: true }}
            value={buttonURL}
            fullWidth
            sx={{
              ...TreffasStyle.formInputLarge("textarea"),
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px !important",
                backgroundColor: "#F4F5F6",
                // minHeight: "100%",
              },
              "& .MuiInputBase-input": {
                fontWeight: 400,
                fontSize: "13px",
                color: "#353A3F",
              },
            }}
            multiline
          />
        </Box>
      </Box>

      <Box
        sx={{
          px: "40px",
          mt: "16px",
          pb: "40px",
        }}
      >
        <CopyToClipboard
          text={buttonURL}
          onCopy={() =>
            showSnackbar(
              t("individual.booking.embed_code.copy.clipboard"),
              "success"
            )
          }
        >
          <TreffasButton
            variant="primary" size="md"
            fullWidth
            sx={{
              minHeight: "44px",
              fontFamily: "var(--font-grenettepromedium)",
              fontSize: "15px",
              lineHeight: "20px",
              borderRadius: "8px",
              }}
            startIcon={<Copy />}
          >
            {t("package.button.copy_embed_code")}
          </TreffasButton>
        </CopyToClipboard>
      </Box>
    </Box>
  );
};

export default EmbedButton;
